export enum PresetRatePrioritizer {
  Cheapest = "CHEAPEST",
  Fastest = "FASTEST",
}
